<template>
  <v-container class="py-1">
    <div class="d-flex text-left pl-2 mb-1">
      <h2 class="text-h4 mb-0 darkred">{{ title }}</h2>
    </div>

    <v-expansion-panels
      v-model="panel"
      multiple
      class="mt-1 mb-2"
    >
      <v-expansion-panel
        v-for="(item, i) in faq"
        :key="i"
      >
        <v-expansion-panel-header class="text-h6 font-weight-bold charcoal text--darken-4">
          {{ item.question }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class=".text-md-body-1 secondary--text">
          {{ item.answer }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    
    </v-expansion-panels>
  </v-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    faq: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.darkred {
  color: #a51d32 !important;
  caret-color: #2d1e28 !important;
}

.charcoal {
  color: #2d1e28 !important;
  caret-color: #a51d32 !important;
}

.v-expansion-panels {
    background: transparent !important; /* Removes background */
    box-shadow: none !important; /* Removes any shadow */
    border: none !important; /* Removes any border */
    justify-content: center;
}

/* Removes the top border between panels */
.v-expansion-panel:not(:first-child)::after {
    border-top: none !important; /* Removes the border */
    content: none !important; /* Prevents the element from rendering */
}

/* Ensure panels don't have borders */
.v-expansion-panel {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    margin-bottom: 4px; /* Optional: Adds some spacing */
}

/* Remove border from expanded panels */
.v-expansion-panel--active {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
}

/* Remove default elevation/shadow */
.v-expansion-panel::before {
    box-shadow: none !important;
    background: transparent !important;
}

/* Remove rounded/bubble effect */
.v-expansion-panel-header {
    border-radius: 0 !important;
    background: transparent !important;
}

/* Optional: Adjust padding */
.v-expansion-panel-content__wrap {
    padding: 10px 0 !important; /* Adjust spacing */
}

.theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: rgb(165 29 50) !important;
}
</style>